import { useCallback, useRef, useState } from 'react';
import { EMPTY_MOBILITY_CONFIG } from '../config/mobility-buttons';
import { useMobilityApiConfig } from './useMobilityApiConfig';
import { useMobilityPreviewListener } from './useMobilityPreviewListener';

export function useMobilityConfig() {
  const previewReceivedRef = useRef(false);
  const [previewConfig, setPreviewConfig] = useState(null);

  const apiState = useMobilityApiConfig(previewReceivedRef);

  const handlePreviewConfig = useCallback((config) => {
    setPreviewConfig(config);
  }, []);

  useMobilityPreviewListener({
    previewReceivedRef,
    onPreviewConfig: handlePreviewConfig,
  });

  if (previewConfig) {
    return { config: previewConfig, loading: false, error: null };
  }

  return {
    config: apiState.config ?? EMPTY_MOBILITY_CONFIG,
    loading: apiState.loading,
    error: apiState.error,
  };
}
